import React from 'react';
import PropTypes from 'prop-types';
import delve from 'dlv';

import { ViewerPrimaryColorUserStyle } from '../../../UserCustomization';

export function SiteCertificationInformation({
  property,
}) {
  function getWebsiteUrl(website) {
    return (typeof website === 'string' && website.match(/^http/)) ? website : `http://${website}`;
  }

  const { additionalDetails } = property;

  return (
    <section>
      <ViewerPrimaryColorUserStyle domStyle="color">
        <h4 className="section-title">Site Certification Information</h4>
      </ViewerPrimaryColorUserStyle>
      <div className="section-body">
        <ul>
          <li>
            <strong>Certified Site Status: </strong>
            {additionalDetails.about.certifiedSiteStatus ? 'Yes' : 'No'}
          </li>
          {(delve(additionalDetails, 'about.certifiedSiteUrl')
            || delve(additionalDetails, 'about.certifiedSiteProgramName')) &&
            <li className={'siteCertificationLink'}>
              <strong>Certified Site: </strong>
              {delve(additionalDetails, 'about.certifiedSiteUrl') &&
              <ViewerPrimaryColorUserStyle domStyle="color">
                <a
                  target="_blank" rel="noopener noreferrer"
                  href={getWebsiteUrl(additionalDetails.about.certifiedSiteUrl)}
                >
                  {
                  additionalDetails.about.certifiedSiteProgramName ?
                    additionalDetails.about.certifiedSiteProgramName :
                    additionalDetails.about.certifiedSiteUrl
                }
                </a>
              </ViewerPrimaryColorUserStyle>
            }
              { (!delve(additionalDetails, 'about.certifiedSiteUrl') &&
            delve(additionalDetails, 'about.certifiedSiteProgramName')) &&
            additionalDetails.about.certifiedSiteProgramName
            }
            </li>
          }
        </ul>
      </div>
    </section>
  );
}

SiteCertificationInformation.propTypes = {
  property: PropTypes.object.isRequired,
};

export default SiteCertificationInformation;



// WEBPACK FOOTER //
// ./src/components/PropertyDetail/PropertyDetailOverview/OverviewSections/SiteCertificationInformation.js